import { useQuery } from '@tanstack/react-query';
import type { AxiosRequestConfig } from 'axios';
import { apiWrapper } from '@/apiWrapper';
import { getEndpoints } from '@/endpoints';
import type { Branch } from '@/features/appointments/utils/Branch';
import useAppointmentStore from '@/store/AppointmentStore';
import useFeatureFlagsStore from '@/store/FeatureFlagsStore';

type BranchesApiResponse = Branch[];

type GetBranchesParams = {
  name?: string;
  zipCode?: string;
};

const getBranches = async (params: GetBranchesParams): Promise<Branch[]> => {
  const { name, zipCode } = params;
  const url = getEndpoints().branches;
  const config: AxiosRequestConfig = {
    method: 'GET',
    params: {
      name: name || undefined,
      zipCode: zipCode || undefined,
    },
  };

  const res = await apiWrapper<BranchesApiResponse>(url, config);
  return res;
};

interface UseBranchesOptions {
  enabled?: boolean;
}

export const useBranches = (
  params: GetBranchesParams,
  options?: UseBranchesOptions,
) => {
  const { enabled = true } = options || {};
  const selectedDestination = useAppointmentStore(
    (state) => state.selectedDestination,
  );
  const featureFlags = useFeatureFlagsStore((state) => state.featureFlags);

  return useQuery({
    queryKey: ['branches', params],
    queryFn: () => getBranches(params),
    staleTime: Number.POSITIVE_INFINITY,
    enabled:
      featureFlags.inBranchAppointments &&
      selectedDestination.workTypeId !== '' &&
      enabled,
  });
};
